import React from "react";
import SealMark from "./SealMark";
import "./PageTitle.css";

const PageTitle = ({ title, subtitle, homeScreen }) => {
  if (homeScreen) {
    return (
      <div className="PageTitle--section Container">
        <h2 className="Section--title">{title}</h2>
      </div>
    );
  }

  return (
    <div className="PageTitle">
      <SealMark className="PageTitle--seal" />
      <div className="Container PageTitle--inner">
        <h1>{title}</h1>
        {subtitle && <p className="PageTitle--subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PageTitle;
